import isEqual from 'lodash/isEqual';
import React from 'react';
import { Link } from 'react-router-dom';
import { Refund } from '@atlassian/cssxp-types-billing';
import RefundImage from '@css-xp/base/assets/img/icon-refund.svg';
import { useSidebar, OpenSidebarRow, FormattedCurrency, FormattedDate } from '@css-xp/base';
import { GloballyAllowedSidebar } from '@atlassian/cssxp-utils-generic';
import { InvoiceRefundStatusLozenge } from './invoice-refund-status-lozenge';
import { SourceSystem } from '@atlassian/cssxp-typescommon';
import isEmpty from 'lodash/isEmpty';

interface Props {
  refunds: Refund[];
  source?: SourceSystem | null;
}

export const RefundResults = (props: Props) => {
  const { isSidebarOpen, payload } = useSidebar();

  const { refunds, source } = props;

  return (
    <div>
      <h2>Refunds</h2>
      <table id="refund" className="aui billing-line-items" data-testid="refund-table-list">
        <colgroup>
          <col className="col-auto" />
          <col className="col-auto" />
          <col className="createdDate-column" />
          {source === SourceSystem.CCP && <col className="col-auto" />}
          <col className="total-column" />
        </colgroup>
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th>Created</th>
            {source === SourceSystem.CCP && <th>Type</th>}
            <th className="amount-cell">Total</th>
          </tr>
        </thead>
        <tbody>
          {refunds.map((refund: Refund) => {
            const rowPayload = {
              refundId: refund.id,
            };

            const isSelected = isSidebarOpen && isEqual(payload, rowPayload);

            return (
              <OpenSidebarRow
                key={refund.id}
                sidebar={GloballyAllowedSidebar.REFUND_PREVIEW}
                payload={rowPayload}
                isSelected={isSelected}
                data-testid={`${refund.id}-selected:${isSelected}`}
              >
                <td className="id col-auto">
                  <Link
                    to={`/refunds/${encodeURIComponent(refund.id)}`}
                    data-testid={`${refund.id}-link`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      //@ts-ignore
                      src={RefundImage}
                      className="avatar medium"
                      height={'30px'}
                      alt="refund"
                      style={{ paddingRight: '6px' }}
                    />
                    {refund.id}
                  </Link>
                </td>
                <td>
                  <InvoiceRefundStatusLozenge status={isEmpty(refund.arn) ? 'PENDING' : 'REFUNDED'} />
                </td>
                <td>{refund.createdDate && <FormattedDate date={refund.createdDate} />}</td>
                {refund.sourceSystem === SourceSystem.CCP && <td>{refund.type}</td>}
                <td className="amount-cell">
                  {refund.total ? (
                    <FormattedCurrency value={refund.total} currency={refund.currency} showCurrencyCode />
                  ) : null}
                </td>
              </OpenSidebarRow>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RefundResults;
